import { render } from "./Homepage.vue?vue&type=template&id=24c6be68&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=24c6be68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24c6be68"

export default script